<script lang="ts">
  import Field from '../../../field/Field.svelte';

  import {preview} from '../../../../store';
  import {getInstance} from '../../../../services/animation';
  function getName() {}

  function volumeChange(e: CustomEvent) {
    getInstance().setMusicVolume(e.detail.value);
  }
</script>

<div class="py-4">
  <div class="flex items-center gap-2 py-2">
    <h1 class="truncate text-xs text-gray-500">{$preview.musicName}</h1>
    <div class="ml-auto">
      <h2 class="rounded-md border bg-zinc-100 px-2 py-1 text-xs font-bold">{$preview.audioLevel}%</h2>
    </div>
  </div>
  <Field type="range" on:change={volumeChange} bind:value={$preview.audioLevel} />
</div>
